import React from 'react';
import { useSelector } from 'react-redux';
import { Link as GatsbyLink } from 'gatsby';
import { Link } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';

import useSystemPages from '../../hooks/useSystemPages';
import { selectors as authSelectors } from '../../store/slices/authSlice';

import { reOrderMessages } from './helpers/reOrderHelper';
import { dispatchAccountEvent } from '../../helpers/dataLayerHelpers/accountDataLayerHelper';

type ReOrderNavigationProps = {
  className?: string;
};

const ReOrderNavigation = ({ className = undefined, ...props }: ReOrderNavigationProps) => {
  const [reOrder] = useSystemPages('reOrder');
  const reOrderPath = reOrder?.path;
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);

  const logGAEvent = () => {
    dispatchAccountEvent('subheader_reorder_click', 'click_on_link', { loggedIn: isLoggedIn });
  };

  return (
    <Link
      as={GatsbyLink}
      to={reOrderPath}
      onClick={logGAEvent}
      variant="secondary"
      iconBefore="repeat"
      className={className}
      {...props}
    >
      <span className="pd-sr-only lg:pd-not-sr-only">
        <FormattedMessage
          id={reOrderMessages.reorderNavigationLinkText.id}
          defaultMessage={reOrderMessages.reorderNavigationLinkText.defaultMessage}
        />
      </span>
    </Link>
  );
};

export default ReOrderNavigation;
